// Shared CSV / Excel-compatible export helpers for the Orders table.
// All exports go through one builder so headers and column order stay in sync
// across Pharmacy Staff, Super Admin, and Dispatcher views.

const csvField = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v).replace(/\r?\n/g, " ").replace(/"/g, '""');
  return `"${s}"`;
};

const HEADERS = [
  "Created", "Order #", "Pharmacy", "Patient", "Phone", "Address",
  "Deliver Type", "Priority", "Status", "Driver", "Route",
  "Miles", "Price", "Copay", "Copay Collected",
];

export function buildOrdersCsv(rows) {
  const lines = [HEADERS.map(csvField).join(",")];
  for (const o of rows) {
    lines.push([
      o.created_at, o.order_number || "", o.pharmacy_nickname || o.pharmacy_name || "",
      o.customer_name || "", o.customer_phone || "", o.address || "",
      o.deliver_type || "", o.priority || "", o.status || "",
      o.driver_name || "", o.route_label || "",
      typeof o.miles === "number" ? o.miles.toFixed(1) : "",
      typeof o.price === "number" ? o.price.toFixed(2) : "",
      typeof o.copay === "number" ? o.copay.toFixed(2) : "",
      typeof o.copay === "number" && o.copay > 0 ? (o.copay_collected ? "yes" : "no") : "",
    ].map(csvField).join(","));
  }
  return lines.join("\n");
}

/**
 * Triggers an immediate download of the rows as an Excel-compatible CSV.
 * @param {Array} rows  Orders to export.
 * @param {string} basename  Filename prefix (without extension).
 * @param {string} [scope]   Optional scope suffix ("today"/"week"/"month").
 */
export function downloadOrdersCsv(rows, basename = "orders", scope = "") {
  const csv = buildOrdersCsv(rows);
  // BOM keeps Excel happy with UTF-8 (à, ñ, …)
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8" });
  const stamp = new Date().toISOString().slice(0, 10);
  const suffix = scope ? `-${scope}` : "";
  const filename = `${basename}${suffix}-${stamp}.csv`;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return { filename, count: rows.length };
}
